import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import Navigator from './components/Navigation';
import LifeTodoToggle from './components/LifeTodoToggle';
import { hashPassword, verifyPassword } from './utils/passwordUtils';
import { isHideoutUnlocked, markHideoutUnlocked } from './utils/hideoutAuth';
import { useMetaTags } from './utils/useMetaTags';
import './font.css';
import './style.css';

// '0114' 평문을 해시해 모듈 로드 시 1회 계산. PasswordModal의 검증 로직과 동일한 방식.
const HIDEOUT_PASSWORD_HASH = hashPassword('0114');

function PageHideout(props: {
  activeNav: number;
  setActiveNav: Dispatch<SetStateAction<number>>;
}) {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [hasError, setHasError] = useState(false);

  useMetaTags({
    title: 'Hideout - Lynkim',
    description: 'Hideout',
    image: '/ogimage.png',
  });

  // /hideout 페이지는 항상 다크 모드로 강제 적용 (다른 페이지로 떠나면 이전 값 복구)
  useEffect(() => {
    const html = document.documentElement;
    const prev = html.getAttribute('data-theme');
    html.setAttribute('data-theme', 'dark');
    return () => {
      if (prev) html.setAttribute('data-theme', prev);
      else html.removeAttribute('data-theme');
    };
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (verifyPassword(password, HIDEOUT_PASSWORD_HASH)) {
      setError('');
      setHasError(false);
      markHideoutUnlocked();
      navigate('/daily');
    } else {
      setError('비밀번호가 일치하지 않아요.');
      setPassword('');
      setHasError(true);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
    if (hasError) {
      setHasError(false);
      setError('');
    }
  };

  // 이미 같은 세션에서 비밀번호를 푼 적이 있다면, hideout에 머무르지 않고 바로 daily로 보낸다.
  // (모든 hook 호출 후 early return — hook 순서 안전.)
  if (isHideoutUnlocked()) {
    return <Navigate to='/daily' replace />;
  }

  return (
    <div>
      <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
      <div className='pageTitle'>Hid<span style={{ letterSpacing: '1px' }}>e</span>out</div>
      <div
        style={{ display: 'flex', justifyContent: 'center', padding: '40px 20px 120px' }}
      >
        <div
          className='password-modal-container password-modal-container--page modal-open'
          style={{ background: 'var(--color-bg-elevated)' }}
        >
          <div className='password-modal-title'>
            입장하기
          </div>
          
          <form onSubmit={handleSubmit} className='password-modal-form'>
            <div>
              <input
                type='password'
                value={password}
                onChange={handleChange}
                placeholder='비밀번호를 입력해주세요'
                className={`password-modal-input ${hasError ? 'password-modal-input-error' : ''}`}
                autoFocus
              />
            </div>
            {error && <div className='password-modal-error-message'>{error}</div>}
            <div className='password-modal-buttons'>
              <button
                type='submit'
                disabled={!password}
                className={`password-modal-button password-modal-button-primary ${password ? 'password-modal-button-active' : ''}`}
              >
                <span>확인</span>
                <svg
                  className='confirm-arrow'
                  xmlns='http://www.w3.org/2000/svg'
                  width='20'
                  height='20'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                >
                  <path d='M5 12h14m-7-7l7 7-7 7' />
                </svg>
              </button>
            </div>
          </form>
        </div>
      </div>
      <LifeTodoToggle />
    </div>
  );
}

export default PageHideout;
